import styles from './Skeleton.module.scss';

interface SkeletonProps {
  className?: string;
}

// Standalone loading placeholder for content that has no element of its own yet
// (card grids, sliders); consumers control size, aspect-ratio and radius via
// `className`. Images do not use this component — HIHImage and HIHImageCaption put
// the class from Skeleton.module.scss on the <img> itself so the placeholder is
// clipped by the image's own border-radius.
const Skeleton: React.FC<SkeletonProps> = ({ className }) => {
  return (
    <div
      className={[styles.skeleton, className].filter(Boolean).join(' ')}
      aria-hidden="true"
    />
  );
};

export default Skeleton;
